// source: calibration/proto/extrinsics.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var geometry_proto_transform_pb = require('../../geometry/proto/transform_pb.js');
goog.object.extend(proto, geometry_proto_transform_pb);
goog.exportSymbol('proto.fox.proto.Extrinsics', null, global);
goog.exportSymbol('proto.fox.proto.RealSenseExtrinsics', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fox.proto.RealSenseExtrinsics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fox.proto.RealSenseExtrinsics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fox.proto.RealSenseExtrinsics.displayName = 'proto.fox.proto.RealSenseExtrinsics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fox.proto.Extrinsics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fox.proto.Extrinsics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fox.proto.Extrinsics.displayName = 'proto.fox.proto.Extrinsics';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fox.proto.RealSenseExtrinsics.prototype.toObject = function(opt_includeInstance) {
  return proto.fox.proto.RealSenseExtrinsics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fox.proto.RealSenseExtrinsics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fox.proto.RealSenseExtrinsics.toObject = function(includeInstance, msg) {
  var f, obj = {
    baseTColorCamera: (f = msg.getBaseTColorCamera()) && geometry_proto_transform_pb.Transform3f.toObject(includeInstance, f),
    baseTDepthCamera: (f = msg.getBaseTDepthCamera()) && geometry_proto_transform_pb.Transform3f.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fox.proto.RealSenseExtrinsics}
 */
proto.fox.proto.RealSenseExtrinsics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fox.proto.RealSenseExtrinsics;
  return proto.fox.proto.RealSenseExtrinsics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fox.proto.RealSenseExtrinsics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fox.proto.RealSenseExtrinsics}
 */
proto.fox.proto.RealSenseExtrinsics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new geometry_proto_transform_pb.Transform3f;
      reader.readMessage(value,geometry_proto_transform_pb.Transform3f.deserializeBinaryFromReader);
      msg.setBaseTColorCamera(value);
      break;
    case 2:
      var value = new geometry_proto_transform_pb.Transform3f;
      reader.readMessage(value,geometry_proto_transform_pb.Transform3f.deserializeBinaryFromReader);
      msg.setBaseTDepthCamera(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fox.proto.RealSenseExtrinsics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fox.proto.RealSenseExtrinsics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fox.proto.RealSenseExtrinsics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fox.proto.RealSenseExtrinsics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBaseTColorCamera();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      geometry_proto_transform_pb.Transform3f.serializeBinaryToWriter
    );
  }
  f = message.getBaseTDepthCamera();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      geometry_proto_transform_pb.Transform3f.serializeBinaryToWriter
    );
  }
};


/**
 * optional Transform3f base_t_color_camera = 1;
 * @return {?proto.fox.proto.Transform3f}
 */
proto.fox.proto.RealSenseExtrinsics.prototype.getBaseTColorCamera = function() {
  return /** @type{?proto.fox.proto.Transform3f} */ (
    jspb.Message.getWrapperField(this, geometry_proto_transform_pb.Transform3f, 1));
};


/**
 * @param {?proto.fox.proto.Transform3f|undefined} value
 * @return {!proto.fox.proto.RealSenseExtrinsics} returns this
*/
proto.fox.proto.RealSenseExtrinsics.prototype.setBaseTColorCamera = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fox.proto.RealSenseExtrinsics} returns this
 */
proto.fox.proto.RealSenseExtrinsics.prototype.clearBaseTColorCamera = function() {
  return this.setBaseTColorCamera(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fox.proto.RealSenseExtrinsics.prototype.hasBaseTColorCamera = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Transform3f base_t_depth_camera = 2;
 * @return {?proto.fox.proto.Transform3f}
 */
proto.fox.proto.RealSenseExtrinsics.prototype.getBaseTDepthCamera = function() {
  return /** @type{?proto.fox.proto.Transform3f} */ (
    jspb.Message.getWrapperField(this, geometry_proto_transform_pb.Transform3f, 2));
};


/**
 * @param {?proto.fox.proto.Transform3f|undefined} value
 * @return {!proto.fox.proto.RealSenseExtrinsics} returns this
*/
proto.fox.proto.RealSenseExtrinsics.prototype.setBaseTDepthCamera = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fox.proto.RealSenseExtrinsics} returns this
 */
proto.fox.proto.RealSenseExtrinsics.prototype.clearBaseTDepthCamera = function() {
  return this.setBaseTDepthCamera(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fox.proto.RealSenseExtrinsics.prototype.hasBaseTDepthCamera = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fox.proto.Extrinsics.prototype.toObject = function(opt_includeInstance) {
  return proto.fox.proto.Extrinsics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fox.proto.Extrinsics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fox.proto.Extrinsics.toObject = function(includeInstance, msg) {
  var f, obj = {
    robotTBlackfly: (f = msg.getRobotTBlackfly()) && geometry_proto_transform_pb.Transform3f.toObject(includeInstance, f),
    robotTIfm: (f = msg.getRobotTIfm()) && geometry_proto_transform_pb.Transform3f.toObject(includeInstance, f),
    robotTLeftScan: (f = msg.getRobotTLeftScan()) && geometry_proto_transform_pb.Transform3f.toObject(includeInstance, f),
    robotTRightScan: (f = msg.getRobotTRightScan()) && geometry_proto_transform_pb.Transform3f.toObject(includeInstance, f),
    robotTSickScan: (f = msg.getRobotTSickScan()) && geometry_proto_transform_pb.Transform3f.toObject(includeInstance, f),
    robotTZed: (f = msg.getRobotTZed()) && geometry_proto_transform_pb.Transform3f.toObject(includeInstance, f),
    carriageTCamera: (f = msg.getCarriageTCamera()) && geometry_proto_transform_pb.Transform3f.toObject(includeInstance, f),
    robotTBackRealsenseBase: (f = msg.getRobotTBackRealsenseBase()) && geometry_proto_transform_pb.Transform3f.toObject(includeInstance, f),
    carriageTBackRealsenseBase: (f = msg.getCarriageTBackRealsenseBase()) && geometry_proto_transform_pb.Transform3f.toObject(includeInstance, f),
    backRealsense: (f = msg.getBackRealsense()) && proto.fox.proto.RealSenseExtrinsics.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fox.proto.Extrinsics}
 */
proto.fox.proto.Extrinsics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fox.proto.Extrinsics;
  return proto.fox.proto.Extrinsics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fox.proto.Extrinsics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fox.proto.Extrinsics}
 */
proto.fox.proto.Extrinsics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new geometry_proto_transform_pb.Transform3f;
      reader.readMessage(value,geometry_proto_transform_pb.Transform3f.deserializeBinaryFromReader);
      msg.setRobotTBlackfly(value);
      break;
    case 2:
      var value = new geometry_proto_transform_pb.Transform3f;
      reader.readMessage(value,geometry_proto_transform_pb.Transform3f.deserializeBinaryFromReader);
      msg.setRobotTIfm(value);
      break;
    case 3:
      var value = new geometry_proto_transform_pb.Transform3f;
      reader.readMessage(value,geometry_proto_transform_pb.Transform3f.deserializeBinaryFromReader);
      msg.setRobotTLeftScan(value);
      break;
    case 4:
      var value = new geometry_proto_transform_pb.Transform3f;
      reader.readMessage(value,geometry_proto_transform_pb.Transform3f.deserializeBinaryFromReader);
      msg.setRobotTRightScan(value);
      break;
    case 5:
      var value = new geometry_proto_transform_pb.Transform3f;
      reader.readMessage(value,geometry_proto_transform_pb.Transform3f.deserializeBinaryFromReader);
      msg.setRobotTSickScan(value);
      break;
    case 6:
      var value = new geometry_proto_transform_pb.Transform3f;
      reader.readMessage(value,geometry_proto_transform_pb.Transform3f.deserializeBinaryFromReader);
      msg.setRobotTZed(value);
      break;
    case 7:
      var value = new geometry_proto_transform_pb.Transform3f;
      reader.readMessage(value,geometry_proto_transform_pb.Transform3f.deserializeBinaryFromReader);
      msg.setCarriageTCamera(value);
      break;
    case 8:
      var value = new geometry_proto_transform_pb.Transform3f;
      reader.readMessage(value,geometry_proto_transform_pb.Transform3f.deserializeBinaryFromReader);
      msg.setRobotTBackRealsenseBase(value);
      break;
    case 9:
      var value = new geometry_proto_transform_pb.Transform3f;
      reader.readMessage(value,geometry_proto_transform_pb.Transform3f.deserializeBinaryFromReader);
      msg.setCarriageTBackRealsenseBase(value);
      break;
    case 10:
      var value = new proto.fox.proto.RealSenseExtrinsics;
      reader.readMessage(value,proto.fox.proto.RealSenseExtrinsics.deserializeBinaryFromReader);
      msg.setBackRealsense(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fox.proto.Extrinsics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fox.proto.Extrinsics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fox.proto.Extrinsics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fox.proto.Extrinsics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRobotTBlackfly();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      geometry_proto_transform_pb.Transform3f.serializeBinaryToWriter
    );
  }
  f = message.getRobotTIfm();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      geometry_proto_transform_pb.Transform3f.serializeBinaryToWriter
    );
  }
  f = message.getRobotTLeftScan();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      geometry_proto_transform_pb.Transform3f.serializeBinaryToWriter
    );
  }
  f = message.getRobotTRightScan();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      geometry_proto_transform_pb.Transform3f.serializeBinaryToWriter
    );
  }
  f = message.getRobotTSickScan();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      geometry_proto_transform_pb.Transform3f.serializeBinaryToWriter
    );
  }
  f = message.getRobotTZed();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      geometry_proto_transform_pb.Transform3f.serializeBinaryToWriter
    );
  }
  f = message.getCarriageTCamera();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      geometry_proto_transform_pb.Transform3f.serializeBinaryToWriter
    );
  }
  f = message.getRobotTBackRealsenseBase();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      geometry_proto_transform_pb.Transform3f.serializeBinaryToWriter
    );
  }
  f = message.getCarriageTBackRealsenseBase();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      geometry_proto_transform_pb.Transform3f.serializeBinaryToWriter
    );
  }
  f = message.getBackRealsense();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.fox.proto.RealSenseExtrinsics.serializeBinaryToWriter
    );
  }
};


/**
 * optional Transform3f robot_t_blackfly = 1;
 * @return {?proto.fox.proto.Transform3f}
 */
proto.fox.proto.Extrinsics.prototype.getRobotTBlackfly = function() {
  return /** @type{?proto.fox.proto.Transform3f} */ (
    jspb.Message.getWrapperField(this, geometry_proto_transform_pb.Transform3f, 1));
};


/**
 * @param {?proto.fox.proto.Transform3f|undefined} value
 * @return {!proto.fox.proto.Extrinsics} returns this
*/
proto.fox.proto.Extrinsics.prototype.setRobotTBlackfly = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fox.proto.Extrinsics} returns this
 */
proto.fox.proto.Extrinsics.prototype.clearRobotTBlackfly = function() {
  return this.setRobotTBlackfly(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fox.proto.Extrinsics.prototype.hasRobotTBlackfly = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Transform3f robot_t_ifm = 2;
 * @return {?proto.fox.proto.Transform3f}
 */
proto.fox.proto.Extrinsics.prototype.getRobotTIfm = function() {
  return /** @type{?proto.fox.proto.Transform3f} */ (
    jspb.Message.getWrapperField(this, geometry_proto_transform_pb.Transform3f, 2));
};


/**
 * @param {?proto.fox.proto.Transform3f|undefined} value
 * @return {!proto.fox.proto.Extrinsics} returns this
*/
proto.fox.proto.Extrinsics.prototype.setRobotTIfm = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fox.proto.Extrinsics} returns this
 */
proto.fox.proto.Extrinsics.prototype.clearRobotTIfm = function() {
  return this.setRobotTIfm(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fox.proto.Extrinsics.prototype.hasRobotTIfm = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Transform3f robot_t_left_scan = 3;
 * @return {?proto.fox.proto.Transform3f}
 */
proto.fox.proto.Extrinsics.prototype.getRobotTLeftScan = function() {
  return /** @type{?proto.fox.proto.Transform3f} */ (
    jspb.Message.getWrapperField(this, geometry_proto_transform_pb.Transform3f, 3));
};


/**
 * @param {?proto.fox.proto.Transform3f|undefined} value
 * @return {!proto.fox.proto.Extrinsics} returns this
*/
proto.fox.proto.Extrinsics.prototype.setRobotTLeftScan = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fox.proto.Extrinsics} returns this
 */
proto.fox.proto.Extrinsics.prototype.clearRobotTLeftScan = function() {
  return this.setRobotTLeftScan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fox.proto.Extrinsics.prototype.hasRobotTLeftScan = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Transform3f robot_t_right_scan = 4;
 * @return {?proto.fox.proto.Transform3f}
 */
proto.fox.proto.Extrinsics.prototype.getRobotTRightScan = function() {
  return /** @type{?proto.fox.proto.Transform3f} */ (
    jspb.Message.getWrapperField(this, geometry_proto_transform_pb.Transform3f, 4));
};


/**
 * @param {?proto.fox.proto.Transform3f|undefined} value
 * @return {!proto.fox.proto.Extrinsics} returns this
*/
proto.fox.proto.Extrinsics.prototype.setRobotTRightScan = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fox.proto.Extrinsics} returns this
 */
proto.fox.proto.Extrinsics.prototype.clearRobotTRightScan = function() {
  return this.setRobotTRightScan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fox.proto.Extrinsics.prototype.hasRobotTRightScan = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Transform3f robot_t_sick_scan = 5;
 * @return {?proto.fox.proto.Transform3f}
 */
proto.fox.proto.Extrinsics.prototype.getRobotTSickScan = function() {
  return /** @type{?proto.fox.proto.Transform3f} */ (
    jspb.Message.getWrapperField(this, geometry_proto_transform_pb.Transform3f, 5));
};


/**
 * @param {?proto.fox.proto.Transform3f|undefined} value
 * @return {!proto.fox.proto.Extrinsics} returns this
*/
proto.fox.proto.Extrinsics.prototype.setRobotTSickScan = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fox.proto.Extrinsics} returns this
 */
proto.fox.proto.Extrinsics.prototype.clearRobotTSickScan = function() {
  return this.setRobotTSickScan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fox.proto.Extrinsics.prototype.hasRobotTSickScan = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Transform3f robot_t_zed = 6;
 * @return {?proto.fox.proto.Transform3f}
 */
proto.fox.proto.Extrinsics.prototype.getRobotTZed = function() {
  return /** @type{?proto.fox.proto.Transform3f} */ (
    jspb.Message.getWrapperField(this, geometry_proto_transform_pb.Transform3f, 6));
};


/**
 * @param {?proto.fox.proto.Transform3f|undefined} value
 * @return {!proto.fox.proto.Extrinsics} returns this
*/
proto.fox.proto.Extrinsics.prototype.setRobotTZed = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fox.proto.Extrinsics} returns this
 */
proto.fox.proto.Extrinsics.prototype.clearRobotTZed = function() {
  return this.setRobotTZed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fox.proto.Extrinsics.prototype.hasRobotTZed = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Transform3f carriage_t_camera = 7;
 * @return {?proto.fox.proto.Transform3f}
 */
proto.fox.proto.Extrinsics.prototype.getCarriageTCamera = function() {
  return /** @type{?proto.fox.proto.Transform3f} */ (
    jspb.Message.getWrapperField(this, geometry_proto_transform_pb.Transform3f, 7));
};


/**
 * @param {?proto.fox.proto.Transform3f|undefined} value
 * @return {!proto.fox.proto.Extrinsics} returns this
*/
proto.fox.proto.Extrinsics.prototype.setCarriageTCamera = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fox.proto.Extrinsics} returns this
 */
proto.fox.proto.Extrinsics.prototype.clearCarriageTCamera = function() {
  return this.setCarriageTCamera(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fox.proto.Extrinsics.prototype.hasCarriageTCamera = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Transform3f robot_t_back_realsense_base = 8;
 * @return {?proto.fox.proto.Transform3f}
 */
proto.fox.proto.Extrinsics.prototype.getRobotTBackRealsenseBase = function() {
  return /** @type{?proto.fox.proto.Transform3f} */ (
    jspb.Message.getWrapperField(this, geometry_proto_transform_pb.Transform3f, 8));
};


/**
 * @param {?proto.fox.proto.Transform3f|undefined} value
 * @return {!proto.fox.proto.Extrinsics} returns this
*/
proto.fox.proto.Extrinsics.prototype.setRobotTBackRealsenseBase = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fox.proto.Extrinsics} returns this
 */
proto.fox.proto.Extrinsics.prototype.clearRobotTBackRealsenseBase = function() {
  return this.setRobotTBackRealsenseBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fox.proto.Extrinsics.prototype.hasRobotTBackRealsenseBase = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional Transform3f carriage_t_back_realsense_base = 9;
 * @return {?proto.fox.proto.Transform3f}
 */
proto.fox.proto.Extrinsics.prototype.getCarriageTBackRealsenseBase = function() {
  return /** @type{?proto.fox.proto.Transform3f} */ (
    jspb.Message.getWrapperField(this, geometry_proto_transform_pb.Transform3f, 9));
};


/**
 * @param {?proto.fox.proto.Transform3f|undefined} value
 * @return {!proto.fox.proto.Extrinsics} returns this
*/
proto.fox.proto.Extrinsics.prototype.setCarriageTBackRealsenseBase = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fox.proto.Extrinsics} returns this
 */
proto.fox.proto.Extrinsics.prototype.clearCarriageTBackRealsenseBase = function() {
  return this.setCarriageTBackRealsenseBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fox.proto.Extrinsics.prototype.hasCarriageTBackRealsenseBase = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional RealSenseExtrinsics back_realsense = 10;
 * @return {?proto.fox.proto.RealSenseExtrinsics}
 */
proto.fox.proto.Extrinsics.prototype.getBackRealsense = function() {
  return /** @type{?proto.fox.proto.RealSenseExtrinsics} */ (
    jspb.Message.getWrapperField(this, proto.fox.proto.RealSenseExtrinsics, 10));
};


/**
 * @param {?proto.fox.proto.RealSenseExtrinsics|undefined} value
 * @return {!proto.fox.proto.Extrinsics} returns this
*/
proto.fox.proto.Extrinsics.prototype.setBackRealsense = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fox.proto.Extrinsics} returns this
 */
proto.fox.proto.Extrinsics.prototype.clearBackRealsense = function() {
  return this.setBackRealsense(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fox.proto.Extrinsics.prototype.hasBackRealsense = function() {
  return jspb.Message.getField(this, 10) != null;
};


goog.object.extend(exports, proto.fox.proto);
